module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "personal-list-program-page",
    style: (_vm.getPageBgStyle())
  }, [_c('div', {
    staticClass: "foo"
  }, [(!_vm.hideTitle) ? _c('H1', [_vm._v(_vm._s(_vm.locale.t('label_my_active_program')))]) : _vm._e(), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "center-wrapper"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.programs.length === 0) ? _c('div', {
    staticClass: "center-wrapper"
  }, [_c('div', {
    staticClass: "centered-div"
  }, [_c('p', {
    staticClass: "no-trainings"
  }, [_vm._v(_vm._s(_vm.locale.t('label_no_active_programs')))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require("../../assets/img/icons/ic_no_trainings.png")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "training-grid"
  }, _vm._l((_vm.programs), function(item, index) {
    return _c('div', {
      key: item.id || index,
      class: ['perosnal-main personal-list-program-page__item', {
        'personal-list-program-page__item--expanded': _vm.isDescriptionExpanded(item)
      }],
      on: {
        "click": function($event) {
          return _vm.showProgram(item, true)
        }
      }
    }, [_c('div', {
      staticClass: "personal-training-main"
    }, [_c('div', {
      staticClass: "personal-training-overlay"
    }), _vm._v(" "), _c('div', {
      staticClass: "personal-training personal-list-program-page__training-image",
      style: ('background-image: url(' + item.imageUrl + ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "personal-trainer-content"
    }, [_c('div', {
      staticClass: "c2 personal-list-program-page__card-content",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleDescription(item)
        }
      }
    }, [_c('p', {
      staticClass: "personal-list-program-page__program-title"
    }, [_vm._v(_vm._s(_vm.getName(item)))]), _c('br'), _vm._v(" "), (_vm.isDescriptionExpanded(item)) ? [_c('p', {
      staticClass: "personal-list-program-page__program-subtitle personal-list-program-page__program-subtitle--expanded"
    }, [_vm._v("-" + _vm._s(_vm.getShortDesc(item)) + "-")]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "personal-list-program-page__program-desc personal-list-program-page__program-desc--expanded"
    }, [_vm._v(_vm._s(_vm.getLongDesc(item)))])] : [_c('p', {
      staticClass: "personal-list-program-page__program-subtitle"
    }, [_vm._v("-" + _vm._s(_vm.getMaxChars(_vm.getShortDesc(item), 90)) + "-")]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "personal-list-program-page__program-desc"
    }, [_vm._v(_vm._s(_vm.getMaxChars(_vm.getLongDesc(item), 100)) + "...")])], _vm._v(" "), _c('div', {
      staticClass: "personal-list-program-page__read-more",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleDescription(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.isDescriptionExpanded(item) ? _vm.locale.t('label_show_less') : _vm.locale.t('label_show_more')) + "\n            ")])], 2), _vm._v(" "), _c('div', {
      staticClass: "personal-training-bottom"
    }, [_c('div', {
      staticClass: "personal-button-show-program personal-list-program-page__cta"
    }, [_c('img', {
      staticClass: "personal-list-program-page__cta-icon",
      attrs: {
        "src": require("../../assets/img/icons/ic_rocket.svg")
      }
    }), _vm._v(" "), (item.free !== true) ? _c('b', {
      staticClass: "personal-list-program-page__cta-label"
    }, [_vm._v(_vm._s(_vm.locale.t('label_start_program')))]) : _vm._e()])])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c1375586!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personal/PersonalListProgramUser.vue
// module id = 822
// module chunks = 0